import { render, staticRenderFns } from "./ResidentialVisa.vue?vue&type=template&id=d76b9eca&"
import script from "./ResidentialVisa.vue?vue&type=script&lang=js&"
export * from "./ResidentialVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports